import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./tipiTiraggioActions";

class TipiTiraggioStore extends AbstractGetAllStore<string>{
    constructor() {
        super(x => x);
        Dispatcher
            .onfunction(Actions.getAll, result => this.setAll(result!))
    }
    public useAll = () => this.useAllWithAction(() => Actions.getAll());
}

export default new TipiTiraggioStore()
